import tool from '@/utils/tool'

const ENUMS = {
  StockCategory: {
    In: tool.vm.$t('Views.Stock.stockCategoryIn'),
    Out: tool.vm.$t('Views.Stock.stockCategoryOut')
  },
  OutStockCategory: {
    PurchaseReturn: tool.vm.$t('Views.Stock.stockCategory-PurchaseReturn'),
    Order: tool.vm.$t('Views.Stock.stockCategory-Order'),
    TransferOut: tool.vm.$t('Views.Stock.stockCategory-TransferOut'),
    Loss: tool.vm.$t('Views.Stock.stockCategory-Loss'),
    OtherOut: tool.vm.$t('Views.Stock.stockCategory-OtherOut')
  },
  InStockCategory: {
    Purchase: tool.vm.$t('Views.Stock.stockCategory-Purchase'),
    Profit: tool.vm.$t('Views.Stock.stockCategory-Profit'),
    Return: tool.vm.$t('Views.Stock.stockCategory-Return'),
    Transfer: tool.vm.$t('Views.Stock.stockCategory-Transfer'),
    CancelOutStock: tool.vm.$t('Views.Stock.stockCategory-CancelOutStock'),
    Other: tool.vm.$t('Views.Stock.stockCategory-Other')
  },
  OutStockStatus: {
    Stocked: tool.vm.$t('Views.Stock.outstockStatus-Stocked'),
    Pending: tool.vm.$t('Views.Stock.stockStatus-Pending'),
    Cancel: tool.vm.$t('Views.Stock.stockStatus-Cancel')
  },
  InStockStatus: {
    Stocked: tool.vm.$t('Views.Stock.instockStatus-Stocked'),
    Pending: tool.vm.$t('Views.Stock.stockStatus-Pending')
  },
  isActive: {
    true: { text: tool.vm.$t('Views.Setting.isActive'), color: '' },
    false: { text: tool.vm.$t('Views.Setting.noActive'), color: '#999999' }
  },
  OperationNames: {
    Recharge: tool.vm.$t('Views.Finance.recharge'),
    Deduct: tool.vm.$t('Views.Finance.deduction'),
    UndoRecharge: tool.vm.$t('Views.Finance.undoRecharge'),
    OrderFreeze: tool.vm.$t('Views.Finance.OrderFreeze'),
    // CancelDeduct: tool.vm.$t('Views.Finance.cancelDedut'),
    CancelFreeze: tool.vm.$t('Views.Finance.CancelFreeze'),
    FreezeDifference: tool.vm.$t('Views.Finance.FreezeDifference')
    // OtherDetailDeduct: tool.vm.$t('Views.Finance.otherDetailDeduct')
    // ManualRecharge: tool.vm.$t('Views.Finance.manualRecharge')
  },
  RechargeStatus: {
    WaitConfirm: {
      text: tool.vm.$t('Views.Finance.WaitConfirm'),
      color: '#FF0000'
    },
    Pass: { text: tool.vm.$t('Views.Finance.pass'), color: '#00A854' },
    NotPass: { text: tool.vm.$t('Views.Finance.notPass'), color: '#FF0000' },
    Ban: { text: tool.vm.$t('Views.Finance.canceled'), color: '#999999' },
    RechargeFailed: {
      text: tool.vm.$t('Views.Finance.failRecharge'),
      color: '#999999'
    },
    ToBeMatched: {
      text: tool.vm.$t('Views.Finance.ToBeMatched'),
      color: '#FF0000'
    },
    Successed: {
      text: tool.vm.$t('Views.Finance.successRecharge'),
      color: '#00A854'
    }
  },
  ManualRechargeStatus: {
    Pass: {
      text: tool.vm.$t('Views.Finance.successRecharge'),
      color: ''
    },
    Ban: { text: tool.vm.$t('Views.Finance.canceled'), color: '#999999' }
  },
  // 商品列表的上下架
  productStatus: {
    OnSale: { text: tool.vm.$t('Views.Goods.onSale'), color: '' },
    StopSale: { text: tool.vm.$t('Views.Goods.stopSale'), color: '#f44336' }
  },
  // 订单列表 订单状态
  orderStatus: {
    Pending: { text: tool.vm.$t('Views.Order.pending'), color: '#FE5500' }, // 待审核
    PartialDelivery: {
      text: tool.vm.$t('Views.Order.partialDelivery'),
      color: '#FF0000'
    }, // 部分发货
    Order: { text: tool.vm.$t('Views.Order.shipped'), color: '#FF0000' }, // 待发货
    Finished: { text: tool.vm.$t('Views.Order.finished'), color: '#000000' }, // 已完成
    Canceled: { text: tool.vm.$t('Views.Order.canceled'), color: '#999999' }, // 已取消
    PendingConfirm: {
      text: tool.vm.$t('Views.Order.beConfirmed'),
      color: '#FF0000'
    }, // 待确认
    PendingPayment: { text: tool.vm.$t('Views.Order.pendingPayment'), color: '#FF0000' } // 待支付
  },
  /** 配货列表的 库存状态 */
  StockStatus: {
    OutOfStock: tool.vm.$t('Views.Order.OutOfStock'),
    StockNotEnough: tool.vm.$t('Views.Order.StockNotEnough'),
    StockEnough: tool.vm.$t('Views.Order.StockEnough')
  },
  /** 发货列表 发货状态 */
  ShipStatus: {
    ToBeShip: tool.vm.$t('Views.Order.ToBeShip'), // '待发货',
    Shipped: tool.vm.$t('Views.Order.Shipped'), // '已发货',
    // ToBeShip: tool.vm.$t('Views.Order.delivering'), // '待配货',
    Cancel: tool.vm.$t('Views.Order.Cancel') // '已取消'
  },
  /** 物流公司 */
  ShipCompany: {
    shunfeng: tool.vm.$t('Views.Order.shunfeng'),
    yuantong: tool.vm.$t('Views.Order.yuantong'),
    debangwuliu: tool.vm.$t('Views.Order.debang')
  },
  // 订单详情 操作类型
  orderOperaType: {
    Submit: { text: tool.vm.$t('Views.Order.placeOrder'), color: '' },
    ConfirmPrice: {
      text: tool.vm.$t('Views.Order.confirmOrderPrice'),
      color: ''
    },
    Approve: { text: tool.vm.$t('Views.Order.approvalOrder'), color: '' },
    BackToConfirm: { text: tool.vm.$t('Views.Order.backToSure'), color: '' },
    AllocationAndOutStock: {
      text: tool.vm.$t('Views.Order.distribution'),
      color: ''
    },
    CancelOutStock: {
      text: tool.vm.$t('Views.Order.revoke'),
      color: ''
    },
    Ship: { text: tool.vm.$t('Views.Order.confirm_ship_label'), color: '' },
    CancelShip: {
      text: tool.vm.$t('Views.Order.cancle_ship_label'),
      color: ''
    },
    CancelOrder: { text: tool.vm.$t('Views.Order.cancelOrder'), color: '' },
    CreateOtherDetails: {
      text: tool.vm.$t('Views.Order.createOtherDetails'),
      color: ''
    },
    EditOtherDetails: {
      text: tool.vm.$t('Views.Order.editOtherDetails'),
      color: ''
    },
    DeleteOtherDetails: {
      text: tool.vm.$t('Views.Order.deleteOtherDetails'),
      color: ''
    },
    EditOrderItem: { text: tool.vm.$t('Views.Order.editOrderItem'), color: '' },
    Payment: { text: tool.vm.$t('Views.Order.payment_opt'), color: '' },
    SumbitSuperiors: { text: tool.vm.$t('Views.Customer.reviewSuperior'), color: '' },
    ModifyExpectShipDate: { text: tool.vm.$t('Views.Order.modifyExpectShipDate'), color: '' }
  },
  CustomerDicountStatus: {
    WaitConfirm: {
      text: tool.vm.$t('Views.Customer.waitConfirm'),
      color: '#f44336'
    },
    Pass: { text: tool.vm.$t('Views.Customer.adopt'), color: '' }
    // NotPass: { text: tool.vm.$t('Views.Customer.reject'), color: '#FF0000' },
    // Ban: { text: tool.vm.$t('Views.Customer.ban'), color: '#999999' }
  },
  // 结算币种
  currencyName: {
    JPY: tool.vm.$t('Views.Order.jpy'),
    USD: tool.vm.$t('Views.Order.usd')
  },
  currencyIds: {
    1: tool.vm.$t('Views.Order.jpy'),
    2: tool.vm.$t('Views.Order.usd')
  },
  // 结算方式
  settlementType: {
    PrePayment: tool.vm.$t('Views.Order.prePayment'),
    PaymentNow: tool.vm.$t('Views.Order.paymentNow'),
    PaymentMonthly: tool.vm.$t('Views.Order.paymentMonthly')
  },
  // 支付状态
  payStatus: {
    Paied: { text: tool.vm.$t('Views.Finance.Paied'), color: '' },
    Partial: { text: tool.vm.$t('Views.Finance.Partial'), color: '#FF9000' },
    Pending: { text: tool.vm.$t('Views.Finance.Pending'), color: '#f44336' }
  },
  monthTypes: {
    MiddleMonth: tool.vm.$t('Views.Customer.MiddleMonth'),
    RearMonth: tool.vm.$t('Views.Customer.RearMonth')
  },
  // 月结付款截止日
  months: {
    // 0: tool.vm.$t('Views.Customer.currentMonth'), // 当月
    1: tool.vm.$t('Views.Customer.nextMonth'), // 下月
    2: tool.vm.$t('Views.Customer.monthAterNext') // 下下月
    // 3: tool.vm.$t('Views.Customer.threeMonth') // 3个月
  },
  customerStatus: {
    // WaitConfirm: { text: tool.vm.$t('Views.Customer.beConfirmed'), color: '#f44336' },
    Active: { text: tool.vm.$t('Views.Customer.actived'), color: '#000000' },
    // NotPass: { text: tool.vm.$t('Views.Customer.reject'), color: '#FF0000' },
    InActive: { text: tool.vm.$t('Views.Customer.inActive'), color: '#999999' }
    // WaitReview: { text: tool.vm.$t('Views.Customer.waitConfirm'), color: '#f44336' }
  },
  systemAccountNames: {
    JPY: tool.vm.$t('Views.Finance.JPYaccount'),
    USD: tool.vm.$t('Views.Finance.USDaccount')
  },
  /** 个人中心 数据权限 */
  PermissionName: {
    All: tool.vm.$t('Views.Mine.all_customer_label'),
    Self: tool.vm.$t('Views.Mine.self_customer_label'),
    Department: tool.vm.$t('Views.Customer.department')
  },
  /** 主题颜色*/
  primaryColor: {
    success: '#5cb860',
    info: '#00d3ee',
    primary: '#9c27b0',
    warning: 'rgb(255, 162, 26)',
    danger: '#f44336'
  },
  /** 收货地址状态 */
  customerAddressStatus: {
    WaitEnterCode: {
      text: tool.vm.$t('Views.Customer.waitEnterCode'),
      color: '#f44336'
    },
    AlreadyEnterCode: {
      text: tool.vm.$t('Views.Customer.alreadyEnterCode'),
      color: ''
    },
    Pending: { text: tool.vm.$t('Views.Customer.beConfirmed'), color: '#f44336' }
  },
  // 银行流水 - 匹配状态
  statementMatchStatus: {
    [null]: '',
    [false]: tool.vm.$t('Views.Statement.matchFail'),
    [true]: tool.vm.$t('Views.Statement.matchSuccess')
  },
  // 银行流水 - 处理类型
  statementOperateType: {
    [null]: '',
    Auto: tool.vm.$t('Views.Statement.autoManage'),
    Manual: tool.vm.$t('Views.Statement.manualManage')
  },
  // 银行流水 -确认状态
  statementStatus: {
    'Pending': tool.vm.$t('Views.Statement.pending'),
    'Processed': tool.vm.$t('Views.Statement.processed')
  },
  // 部门列表
  departments: {
    'Sale': tool.vm.$t('Views.Customer.sale_dpt'),
    'Manager': tool.vm.$t('Views.Customer.manager_dpt')
  },
  // 部门审核状态
  departmentStatus: {
    Pending: { text: tool.vm.$t('Views.Customer.waitConfirm'), color: '#f44336' },
    Reject: { text: tool.vm.$t('Views.Customer.reject'), color: '#FF0000' },
    Approve: { text: tool.vm.$t('Views.Customer.adopt'), color: '' }
  },
  // 配货状态
  distrbuteType: {
    Pending: { text: tool.vm.$t('Views.Order.delivering'), color: '#FF0000' }, // 待配货
    Partial: {
      text: tool.vm.$t('Views.Order.deliveredPartial'),
      color: '#FF0000'
    }, // 部份配货
    Finished: { text: tool.vm.$t('Views.Order.delivered'), color: '' }, // 配货完成
    Canceld: { text: tool.vm.$t('Views.Order.Cancel'), color: '#999999' } // 已取消
  },
  // 收货地址区分
  deliveryAddressType: {
    LocalCompany: tool.vm.$t('Views.Customer.localCompany'),
    ReceiptAddress: tool.vm.$t('Views.Customer.receiptAddress'),
    RequestAddress: tool.vm.$t('Views.Customer.requestAddress')
  },
  // 发货地址区分
  allocationAddressType: {
    Local: tool.vm.$t('Views.Order.local'),
    Overseas: tool.vm.$t('Views.Order.overseas')
  },
  // 期望送达时间
  expectDeliveryTime: {
    Morning: tool.vm.$t('Views.Order.morningDate'),
    FourteenToSixteen: '14:00-16:00',
    SixteenToEighteen: '16:00-18:00',
    EighteenToTwenty: '18:00-20:00',
    NineteenToTwentyOne: '19:00-21:00'
  },
  // 已输出CSV
  CSVOutput: {
    true: '出力待ち',
    false: '出力済み'
  },
  // 客户类型
  customerTypes: {
    ChineseSalon: '中国サロン（上海・香港子会社売上：LeCiel及びAXXZIA）',
    ChineseRetail: '中国リテール（小売店・百貨店）（本社直）',
    CrossBorderECTaobao: '越境EC：TaoBao・その他プラットフォーム',
    CrossBorderECTmallUnloading: '越境EC：T-Mall（卸）',
    CrossBorderECTmall: '越境EC：T-Mall旗艦店・RED旗艦店・Inagora・ANA越境EC',
    DomesticDutyFree: '国内免税ドラッグストア',
    LotteSillaDutyFree: 'ロッテ・新羅免税店',
    HanedaNaritaChangiNichiyoShinzen: '羽田・成田・チャンギ・日免・深免',
    DomesticSalon: '国内サロン',
    DomesticRetail: '国内リテール（小売店・百貨店）',
    DomesticEC: '国内EC：Amazon・Yahoo・楽天・自社EC'
  },
  // 汇款手续费
  deliveryFeeTypes: {
    DeliveryFeePrepaid: '当社負担',
    DeliverFeeToBeCollected: '相手方負担'
  },
  // 上市公司
  listCompanyTypes: {
    Listed: '上場',
    UnListed: '非上場'
  },
  // 出货单指示
  OrderShipmentInstruction: {
    DisplayMoney: tool.vm.$t('Views.Order.showPrice'),
    NotDisplayMoney: tool.vm.$t('Views.Order.hidePrice'),
    NoShipmentBill: tool.vm.$t('Views.Order.hideAllo')
  },
  // 入金分配状态
  paymentsMatchStatus: {
    Pending: tool.vm.$t('Views.Dashboard.pending_dispatch_pay'),
    Processed: tool.vm.$t('Views.Statement.processed')
  },
  // 入金审核状态
  paymentsApproveStatus: {
    Pending: { text: tool.vm.$t('Views.Order.pending'), color: '#f44336' },
    Passed: { text: tool.vm.$t('Views.Finance.pass'), color: '' },
    NotPass: { text: tool.vm.$t('Views.Finance.notPass'), color: '' }
  },
  // 在职状态
  staffStatus: {
    OnTheJob: { text: tool.vm.$t('Views.Setting.onTheJob'), color: '#5cb860' },
    Resigned: { text: tool.vm.$t('Views.Setting.resigned'), color: '#ababab' },
    Absence: { text: tool.vm.$t('Views.Setting.absence'), color: '#5cb860' },
    LongVacation: { text: tool.vm.$t('Views.Setting.longVacation'), color: '#5cb860' }
  },
  // 授权状态
  salesStatus: {
    Valid: { text: tool.vm.$t('Views.Sales.effective'), color: '#5cb860' },
    InValid: { text: tool.vm.$t('Views.Sales.ineffective'), color: '#ababab' },
    Expired: { text: tool.vm.$t('Views.Sales.expiered'), color: '#ababab' }
  },
  // 跳转连接类型
  advertiseJumpType: {
    Product: { text: tool.vm.$t('Views.Sales.associateProduct'), value: 'Product' },
    Href: { text: tool.vm.$t('Views.Sales.outsideHref'), value: 'Href' }
  },
  // 显示范围
  advertiseShowType: {
    All: { text: tool.vm.$t('Views.Sales.allShow'), value: 'All' },
    Part: { text: tool.vm.$t('Views.Sales.partShow'), value: 'Part' }
  },
  // 授权状态
  advertiseStatus: {
    Enabled: { text: tool.vm.$t('Views.Sales.actived'), color: '#5bb85f', value: 'Enabled' },
    Disabled: { text: tool.vm.$t('Views.Sales.inActive'), color: '#999999', value: 'Disabled' }
  },
  // 送达时间
  deliveryTime: {
    Morning: tool.vm.$t('Views.Order.morning'),
    FourteenToSixteen: tool.vm.$t('Views.Order.fourteenToSixteen'),
    SixteenToEighteen: tool.vm.$t('Views.Order.sixteenToEighteen'),
    EighteenToTwenty: tool.vm.$t('Views.Order.eighteenToTwenty'),
    NineteenToTwentyOne: tool.vm.$t('Views.Order.nineteenToTwentyOne')
  }
}

export default ENUMS
